var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-container",
      class: { slider: _vm.isSlider },
      on: {
        click: function($event) {
          return _vm.selectProduct(_vm.product)
        }
      }
    },
    [
      _c("div", { staticClass: "product-image-container" }, [
        _c("img", {
          staticClass: "main-image",
          attrs: {
            width: "280",
            height: "280",
            loading: "lazy",
            src: _vm._f("getProductImage")(_vm.product)
          }
        }),
        _vm._v(" "),
        _vm.isPreorder
          ? _c(
              "p",
              {
                staticClass:
                  "preorder-tag lh-1 rounded-sm body-small pd-05rem font-bold bg-pink color-link flex flex-align-center gap-05vw"
              },
              [
                _c("img", {
                  staticClass: "preorder-tag-icon",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Preorder.svg?v=1754334770",
                    width: "15",
                    height: "15",
                    alt: "preorder"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "preorder-tag-text color-link lh-1" },
                  [_vm._v("Available for Preorder")]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "hb-btn secondary",
          class: { "body-small": _vm.isSlider },
          on: {
            click: function($event) {
              return _vm.selectProduct(_vm.product)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.product.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "product-price-container" }, [
        _vm.product.variants.find(function(x) {
          return x.price != "" && x.price != "0.00"
        }).compare_at_price
          ? _c("span", { staticClass: "discount-price" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("moneySaleFormat")(
                      _vm.product.variants.find(function(x) {
                        return x.price != "" && x.price != "0.00"
                      }).compare_at_price
                    )
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "price" }, [
          _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.product)))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }